import { useLocation } from "wouter";
import { AlertTriangle } from "lucide-react";
import { useMartinaUsageControl } from '@/hooks/useMartinaUsageControl';

/**
 * Avviso globale solo per sospensione LLM: Martina non genera contenuti.
 *
 * Google Maps ha un indicatore dedicato in sidebar (stesso piano del residuo
 * LLM). Non deve riapparire come banner "limite Google" su tutta l'app:
 * Workspace (Calendar/Gmail/Drive) non e' sotto quel controllo, e un avviso
 * permanente per blocco automatico disabilitato confonde un kill-switch Maps
 * con un guasto di sistema.
 */
export function MartinaUsageSuspendedBanner() {
  const [, navigate] = useLocation();
  const { data } = useMartinaUsageControl();

  const control = data?.control;
  const balance = data?.llmRealBalance;
  const llmReason = control?.llm.reason ?? "";
  const llmIsBurstBlock = /raffica/i.test(llmReason);

  if (!control?.llm.suspended) return null;

  const balanceHint = !llmIsBurstBlock && balance?.status === 'ok' && balance.availableUsd !== null
    ? ` Saldo reale residuo sul provider attivo: $${balance.availableUsd.toFixed(2)}.`
    : "";

  const label = llmIsBurstBlock
    ? "LLM (raffica anomala rilevata: freno di sicurezza anti-loop)"
    : "LLM (Martina non genera nuovi contenuti)";

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-[color:var(--ma-red)]/30 bg-[color:var(--ma-red-bg)] px-4 py-2 text-xs text-[color:var(--ma-red)] sm:text-sm"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="min-w-0 flex-1">
        <strong className="font-semibold">Sospeso per sicurezza.</strong>{" "}
        {label} — fino al rinnovo del mese, a un tetto più alto, o a una verifica manuale.{balanceHint}
      </span>
      <button
        type="button"
        onClick={() => navigate("/settings/ai")}
        className="shrink-0 rounded-lg border border-[color:var(--ma-red)]/40 px-2.5 py-1 text-xs font-medium text-[color:var(--ma-red)] hover:bg-[color:var(--ma-red)]/10"
      >
        Gestisci budget
      </button>
    </div>
  );
}
